export default "/fonts/poppins-v9-latin-regular.ttf?12a774c768b48a28e8707d618822aa3e";